import { PolarisTimelineMode } from '@atlassian/jira-polaris-domain-view/src/timeline/types.tsx';

export const getTimelineMinColumnWidth = (mode: PolarisTimelineMode) =>
	mode === PolarisTimelineMode.MONTHS ? 110 : 55;
export const getTimelineMaxColumnWidth = (mode: PolarisTimelineMode) =>
	mode === PolarisTimelineMode.MONTHS ? 200 : 100;
